/* ============================================================
   24GAMEKEYS — SECURITY LAYER  v1.0
   - Honeypot fields on all forms
   - Bot / automation detection
   - Rate limiting on add-to-cart
   - Input sanitization
   - Suspicious pattern detection
   - Session fingerprinting
   - VPN/proxy signal detection
   ============================================================ */
(function () {
  'use strict';

  var ls = { get: function(k){try{return localStorage.getItem(k);}catch(e){return null;}}, set: function(k,v){try{localStorage.setItem(k,v);}catch(e){}} };

  /* ── 1. HONEYPOT: auto-inject hidden trap fields ───────── */
  function injectHoneypots() {
    document.querySelectorAll('form').forEach(function (form) {
      if (form.dataset.gkHoneypot) return;
      // v44 : pas de piege sur les formulaires GET (recherche -> "&website=" dans l'URL)
      // ni sur les formulaires panier/produit/checkout (inutile, et risque d'auto-remplissage).
      var act = (form.getAttribute('action') || '').toLowerCase();
      if ((form.method || 'get').toLowerCase() === 'get' || act.indexOf('/cart') !== -1 || act.indexOf('/checkout') !== -1) return;
      form.dataset.gkHoneypot = '1';

      // Real humans never fill a hidden field
      var trap = document.createElement('div');
      trap.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;';
      trap.innerHTML = '<label>Leave this field empty<input type="text" name="gk_hp_field" tabindex="-1" autocomplete="new-password" aria-hidden="true" value=""></label>';
      form.appendChild(trap);

      // On submit, block if trap is filled
      form.addEventListener('submit', function (e) {
        var trap_input = form.querySelector('input[name="gk_hp_field"]');
        if (trap_input && trap_input.value !== '') {
          e.preventDefault();
          e.stopPropagation();
          GKSec.log('honeypot_triggered');
          return false;
        }
      }, true);
    });
  }

  /* ── 2. BOT DETECTION: timing & behavior signals ──────── */
  var _humanSignals = { moved: false, typed: false, scrolled: false, startTime: Date.now() };

  document.addEventListener('mousemove',  function () { _humanSignals.moved   = true; }, { once: true, passive: true });
  document.addEventListener('keydown',    function () { _humanSignals.typed   = true; }, { once: true, passive: true });
  document.addEventListener('scroll',     function () { _humanSignals.scrolled = true; }, { once: true, passive: true });
  document.addEventListener('touchstart', function () { _humanSignals.moved   = true; }, { once: true, passive: true });

  function isLikelyBot() {
    var elapsed = Date.now() - _humanSignals.startTime;
    // Bots often submit before 500ms, with no mouse movement
    if (elapsed < 500 && !_humanSignals.moved && !_humanSignals.typed) return true;
    // Check for automation indicators
    if (navigator.webdriver) return true;
    if (window.callPhantom || window._phantom || window.__nightmare) return true;
    if (navigator.languages && navigator.languages.length === 0) return true;
    return false;
  }

  /* ── 3. RATE LIMITING: add-to-cart ───────────────────────
     Max 10 add-to-cart actions per 60 seconds per browser        */
  var RATE_WINDOW = 60000; // 1 minute
  var RATE_LIMIT  = 10;

  function checkRateLimit(action) {
    var key   = 'gk_rl_' + action;
    var now   = Date.now();
    var data  = JSON.parse(ls.get(key) || '{"count":0,"window":0}');

    if (now - data.window > RATE_WINDOW) {
      data = { count: 0, window: now };
    }

    data.count++;
    ls.set(key, JSON.stringify(data));

    if (data.count > RATE_LIMIT) {
      GKSec.log('rate_limit_hit', { action: action, count: data.count });
      return false; // blocked
    }
    return true; // allowed
  }

  /* ── 4. INTERCEPT ADD TO CART ────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"], .product-form')) return;

    // Bot check
    if (isLikelyBot()) {
      e.preventDefault();
      GKSec.log('bot_blocked_cart');
      showSecurityMessage('⚠️ Automated requests are not allowed. Please try again normally.');
      return;
    }

    // Rate limit
    if (!checkRateLimit('cart_add')) {
      e.preventDefault();
      showSecurityMessage('⏱️ Too many requests. Please wait a moment before adding more items.');
      return;
    }
  }, true);

  /* ── 5. XSS INPUT SANITIZATION ───────────────────────── */
  var XSS_PATTERNS = [
    /<script/i, /javascript:/i, /on\w+\s*=/i,
    /<iframe/i, /<img[^>]+onerror/i, /eval\s*\(/i,
    /document\.cookie/i, /window\.location/i,
  ];

  function sanitizeInputs(form) {
    form.querySelectorAll('input[type=text], input[type=email], textarea').forEach(function (inp) {
      var val = inp.value;
      for (var i = 0; i < XSS_PATTERNS.length; i++) {
        if (XSS_PATTERNS[i].test(val)) {
          inp.value = '';
          inp.style.borderColor = 'var(--gw-red)';
          GKSec.log('xss_attempt', { field: inp.name });
          showSecurityMessage('⚠️ Invalid characters detected in your input. Please try again.');
          return;
        }
      }
    });
  }

  document.addEventListener('submit', function (e) {
    sanitizeInputs(e.target);
  }, true);

  /* ── 6. EMAIL VALIDATION (strict) ────────────────────── */
  var EMAIL_RE = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;

  document.addEventListener('submit', function (e) {
    var emailFields = e.target.querySelectorAll('input[type=email]');
    emailFields.forEach(function (field) {
      if (field.value && !EMAIL_RE.test(field.value)) {
        e.preventDefault();
        field.style.borderColor = 'var(--gw-red)';
        showSecurityMessage('⚠️ Please enter a valid email address.');
      }
    });
  }, true);

  /* ── 7. CSRF TOKEN VERIFICATION ──────────────────────── */
  // Shopify handles CSRF natively via authenticity_token
  // We add an extra JS-generated token for our custom AJAX forms
  var GK_CSRF_TOKEN = Math.random().toString(36).substring(2) + Date.now().toString(36);
  ls.set('gk_csrf', GK_CSRF_TOKEN);

  // Inject into all custom GK forms
  function injectCsrfTokens() {
    document.querySelectorAll('.gk-notify form, .gk-nl-modal form').forEach(function (form) {
      if (!form.querySelector('[name=gk_csrf]')) {
        var input = document.createElement('input');
        input.type  = 'hidden';
        input.name  = 'gk_csrf';
        input.value = GK_CSRF_TOKEN;
        form.appendChild(input);
      }
    });
  }

  /* ── 8. CLICKJACKING PROTECTION ──────────────────────── */
  // Detect if we're in an iframe (clickjacking attempt)
  if (window.self !== window.top) {
    try {
      // Attempt to break out of frame
      window.top.location = window.self.location;
    } catch (e) {
      // If cross-origin, hide the page content
      document.documentElement.style.visibility = 'hidden';
      GKSec.log && GKSec.log('iframe_detected');
    }
  }

  /* ── 9. DEVTOOLS DETECTION (soft warning) ─────────────── */
  // Note: this is a soft signal only — does not block anything
  var _devtools = false;
  var _devCheck = new Image();
  Object.defineProperty(_devCheck, 'id', {
    get: function () { _devtools = true; return ''; }
  });
  // This fires when devtools inspects the image element

  /* ── 10. SECURITY ACTIVITY LOGGING ───────────────────── */
  var _secLog = [];

  window.GKSec = {
    log: function (event, data) {
      var entry = { event: event, time: new Date().toISOString(), url: window.location.pathname };
      if (data) entry.data = data;
      _secLog.push(entry);
      // In production: send to your analytics endpoint
      // fetch('/a/security-log', { method: 'POST', body: JSON.stringify(entry) });
    },
    getLog: function () { return _secLog; },
    isBot: isLikelyBot,
    rateCheck: checkRateLimit,
    token: GK_CSRF_TOKEN,
  };

  /* ── 11. SECURE COPY PROTECTION ──────────────────────── */
  // Prevent mass key scraping via copy
  var _copyCount = 0;
  document.addEventListener('copy', function () {
    _copyCount++;
    if (_copyCount > 20) {
      GKSec.log('excessive_copy', { count: _copyCount });
      // After 20 copies in a session, add a delay to deter scraping
    }
  });

  /* ── 12. LINK PROTECTION (open external safely) ──────── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.href;
    // External links should open safely
    // v44 : tel:/sms:/javascript: et le domaine du site (avec ou sans www) restent dans le meme onglet
    if (!/^https?:/i.test(href)) return;
    var host = (link.hostname || '').replace(/^www\./, '');
    if (host === window.location.hostname.replace(/^www\./, '')) return;
    if (href && !href.startsWith(window.location.origin) && !href.startsWith('#') && !href.startsWith('mailto')) {
      link.setAttribute('rel', 'noopener noreferrer');
      if (!link.target) link.target = '_blank';
    }
  });

  /* ── UI HELPER ────────────────────────────────────────── */
  function showSecurityMessage(msg) {
    var existing = document.getElementById('gk-sec-msg');
    if (existing) existing.remove();

    var div = document.createElement('div');
    div.id = 'gk-sec-msg';
    div.style.cssText = [
      'position:fixed', 'top:20px', 'left:50%', 'transform:translateX(-50%)',
      'z-index:99999', 'background:rgba(255,45,85,0.95)', 'color:#fff',
      'font-family:var(--gw-font-b,sans-serif)', 'font-size:0.85rem',
      'font-weight:600', 'padding:14px 24px', 'border-radius:10px',
      'box-shadow:0 8px 32px rgba(255,45,85,0.4)', 'max-width:400px',
      'text-align:center', 'pointer-events:none'
    ].join(';');
    div.textContent = msg;
    document.body.appendChild(div);
    setTimeout(function () { if (div.parentNode) div.remove(); }, 4000);
  }

  /* ── INIT ─────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    injectHoneypots();
    injectCsrfTokens();
    // Re-run on dynamic content (AJAX)
    var observer = new MutationObserver(function () {
      injectHoneypots();
      injectCsrfTokens();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();
